"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFieldAccessor = exports.useAccessor = exports.useAccessorFromArray = exports.useStateAccessor = void 0;
const react_1 = require("react");
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const bindField = (obj) => {
    obj.setValue = obj.setValue.bind(obj);
    return obj;
};
function useStateAccessor(initialValue) {
    return useAccessorFromArray((0, react_1.useState)(initialValue));
}
exports.useStateAccessor = useStateAccessor;
// useState形式のAccessorを AccessorObjectに変換する
function useAccessorFromArray(source) {
    const obj = (0, react_1.useMemo)(() => bindField({
        value: source[0],
        setValue(value) {
            this.value = value;
            source[1](value);
        },
    }), [source[1]]);
    (0, react_1.useMemo)(() => {
        obj.value = source[0];
    }, [source[0]]);
    return obj;
}
exports.useAccessorFromArray = useAccessorFromArray;
// useState形式のAccessorを AccessorObjectに変換する
function useAccessor(value, setValue) {
    return useAccessorFromArray([value, setValue]);
}
exports.useAccessor = useAccessor;
function useFieldAccessor(parent, key) {
    return (0, react_1.useMemo)(() => {
        return bindField({
            get value() {
                var _a;
                return (_a = parent.value) === null || _a === void 0 ? void 0 : _a[key];
            },
            setValue(newValue) {
                var _a;
                const value = (_a = parent.value) === null || _a === void 0 ? void 0 : _a[key];
                if (newValue !== value) {
                    // ここで isEqualにするより、いったんparent.setValueを呼び出して、そこで解決してもらった方が良い（無駄な更新を避けられる）
                    // このためには、setValueが更新後の値を返す必要があり、useState形式との互換性がなくなる。
                    if (!(0, isEqual_1.default)(this.value, newValue)) {
                        if (newValue !== undefined) {
                            parent.setValue(Object.assign(Object.assign({}, parent.value), { [key]: newValue }));
                        }
                        else {
                            const newParentValue = Object.assign({}, parent.value);
                            delete newParentValue[key];
                            parent.setValue(newParentValue);
                        }
                    }
                }
            },
        });
    }, [parent]);
}
exports.useFieldAccessor = useFieldAccessor;
// const exmaple = () => {
//   const accessor = useStateAccessor<{ condition: { a: string } }>();
//   const childAccessor = useFieldAccessor(accessor, "condition");
//   childAccessor.setValue({ a: "10" });
//   const x = childAccessor.value;
//   const grandchildAccessor = useFieldAccessor(childAccessor, "a");
// };
